// Port of api/fuel/app/classes/insights/records/summary.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import Util from 'offline/util'

function formatDate(format, timestamp) {
	if (!timestamp) return ''
	var output = format || 'd.m.y'
	output = output.replace(/d/g, Util.date('d', timestamp))
	output = output.replace(/m/g, Util.date('m', timestamp))
	output = output.replace(/y/g, Util.date('y', timestamp))
	return output
}

export default Segment.extend({
	name: 'summary',
	types: [Constants.TYPE_USER],
	requires: ['init', 'streaks', 'stats'],
	insight: false,
	detail: false,
	run: function(type, owner) {
		var summary = {
			streaks: {
				win: { value: 0, text: '', plays: [] },
				loss: { value: 0, text: '', plays: [] },
				play: { value: 0, text: '', plays: [] },
				drought: { value: 0, text: '', plays: [] }
			},
			stats: {
				day: { value: 0, text: '', plays: [] },
				overall: { value: 0, text: '' },
				new: { value: 0, text: '', plays: [] }
			}
		}

		var formatSource = Config.user(owner.get_id())
		var format = ((formatSource.other && formatSource.other.date) ? formatSource.other.date : 'DD/MM/YYYY')
			.replace('DD', 'd')
			.replace('MM', 'm')
			.replace('YYYY', 'y')
			.replace(/\//g, '.')

		var streakData = this._data.streaks || {}

		var streakTypes = ['win', 'loss', 'play', 'drought']
		for (var i = 0; i < streakTypes.length; i++) {
			var streakType = streakTypes[i]
			if ((streakData[streakType] || []).length) {
				var topStreak = streakData[streakType][0]
				summary.streaks[streakType].value = topStreak.count
				summary.streaks[streakType].plays = topStreak.plays
				summary.streaks[streakType].text = formatDate(format, topStreak.date.first)

				if (topStreak.date.first !== topStreak.date.last) {
					summary.streaks[streakType].text += ' - ' + formatDate(format, topStreak.date.last)
				}
			}
		}

		var total = 0
		var applicable = 0
		var wins = 0

		var statsData = this._data.stats || {}
		var statTypes = ['day', 'new']
		for (var j = 0; j < statTypes.length; j++) {
			var statType = statTypes[j]
			if ((statsData[statType] || []).length) {
				var topStat = statsData[statType][0]
				summary.stats[statType].value = topStat.count
				summary.stats[statType].plays = topStat.plays
				summary.stats[statType].text = formatDate(format, topStat.date)
			}
		}

		var plays = this._data.plays || []
		for (var p = 0; p < plays.length; p++) {
			if (plays[p].result) applicable += parseInt(plays[p].count, 10)
			total += parseInt(plays[p].count, 10)
			if (plays[p].won) wins += parseInt(plays[p].count, 10)
		}

		if (applicable) {
			summary.stats.overall.value = (100 / applicable) * wins
			summary.stats.overall.text = applicable
		}

		return {
			plays: {
				total: total,
				applicable: applicable
			},
			summary: summary
		}
	}
})
